import APIClient from '@/shared/http/clients/api'

const resourceName = 'TipoInconformidade'
const APIBusinessCommon = process.env.APIBaseURLBusinessCommon
const GetAll = (data = {}, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}`, data, config)

const typenonconformityRepository = {
  GetAll
}
export default typenonconformityRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/business/typenonconformity.js